import Funding from './Funding';

export default Funding;
